import React from 'react';

export default function AceLogo({ width = 44, style, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="30 30 140 140"
      width={width}
      height={width}
      style={style}
      className={className}
      aria-label="Ace Logistics Management"
    >
      <line x1="100" y1="50" x2="100" y2="110" stroke="#06B6D4" strokeWidth="2" strokeDasharray="4 4" opacity="0.7"/>
      <line x1="70" y1="110" x2="100" y2="150" stroke="#3B82F6" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.5"/>
      <line x1="100" y1="50" x2="50" y2="150" stroke="#3B82F6" strokeWidth="3.5" strokeLinecap="round"/>
      <line x1="100" y1="50" x2="150" y2="150" stroke="#3B82F6" strokeWidth="3.5" strokeLinecap="round"/>
      <line x1="70" y1="110" x2="130" y2="110" stroke="#3B82F6" strokeWidth="3.5" strokeLinecap="round"/>
      <circle cx="100" cy="50" r="7" fill="#06B6D4"/>
      <circle cx="100" cy="50" r="13" fill="#06B6D4" fillOpacity="0.15"/>
      <circle cx="70" cy="110" r="4.5" fill="#3B82F6"/>
      <circle cx="130" cy="110" r="4.5" fill="#3B82F6"/>
      <circle cx="100" cy="110" r="4" fill="#06B6D4"/>
      <circle cx="50" cy="150" r="5" fill="#3B82F6"/>
      <circle cx="150" cy="150" r="5" fill="#3B82F6"/>
    </svg>
  );
}
